import { type Unit } from '@rematter/frontend-lib-api-client';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export type PeriodBalanceRecord = {
  id: string;
  itemName: string;
  accountName: string;
  quantity: number;
  quantityUnit: Unit;
  totalValue: number;
  currencyCode: string;
  wacPerUnit: number;
};

export const inventoryPeriodBalancesQueryAtom = createQueryAtomFactory(
  'inventory.inventoryPeriodBalances',
  (params: { inventoryPeriodId: string }) => ({
    inventoryPeriodBalances: {
      __args: {
        filter: { inventoryPeriodIds: [params.inventoryPeriodId] },
        pagination: { limit: 500, offset: 0 },
      },
      page: {
        total: true,
      },
      entries: {
        id: true,
        quantity: true,
        quantityUnit: true,
        totalValue: true,
        currencyCode: true,
        wacPerUnit: true,
        item: {
          id: true,
          name: true,
        },
        account: {
          id: true,
          name: true,
        },
      },
    },
  }),
  {
    select: (data): PeriodBalanceRecord[] => {
      const entries = data?.inventoryPeriodBalances?.entries;
      if (!entries) return [];

      return entries.map((entry) => ({
        id: entry.id,
        itemName: entry.item?.name ?? '',
        accountName: entry.account?.name ?? '',
        quantity: entry.quantity,
        quantityUnit: entry.quantityUnit,
        totalValue: entry.totalValue,
        currencyCode: entry.currencyCode,
        wacPerUnit: entry.wacPerUnit,
      }));
    },
  },
);
